// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__17pIJ","header":"Messages_header__MStu4"};